"use client";

import React, { useEffect, useState } from "react";
import Link from "next/link";
import { ImageKit } from "@aph/ui-lib-humanx";
import { HamburgerData } from "./interface";
import styles from "./HamburgerInfo.module.scss";

interface HamburgerInfoProps {
  handleOpen: (open: boolean) => void;
  hamburgerData: HamburgerData;
  showInSSR: boolean;
}

const HamburgerInfo: React.FC<HamburgerInfoProps> = (props) => {
  const { handleOpen, hamburgerData, showInSSR } = props;
  const [showSubLinks, setShowSubLinks] = useState<boolean>(showInSSR);

  const handleShowSubLinks = () => {
    setShowSubLinks((prevState) => !prevState);
  };

  useEffect(() => {
    setShowSubLinks(showInSSR);
  }, [showInSSR]);

  const getIconClass = (iconName: string) => {
    const iconStyle = styles[iconName as keyof typeof styles];

    return iconStyle ? `${iconStyle} ${styles.icon}` : styles.icon;
  };

  return (
    <>
      <div className={styles.hamburgerList}>
        {hamburgerData?.link ? (
          <Link href={hamburgerData?.link} onClick={() => handleOpen(false)}>
            <div className={styles.list}>
              {hamburgerData?.icon ? (
                <span className={getIconClass(hamburgerData.icon)} />
              ) : hamburgerData?.image ? (
                <ImageKit
                  alt="icons"
                  src={hamburgerData.image}
                  width={16}
                  height={16}
                  format="auto"
                  className={styles.imgIcon}
                />
              ) : null}
              {hamburgerData?.title}
            </div>
          </Link>
        ) : (
          <div onClick={handleShowSubLinks} className={styles.list}>
            {hamburgerData?.icon ? (
              <span className={getIconClass(hamburgerData.icon)} />
            ) : hamburgerData?.image ? (
              <ImageKit
                alt="icons"
                src={hamburgerData.image}
                width={16}
                height={16}
                format="auto"
                className={styles.imgIcon}
              />
            ) : null}
            {hamburgerData?.title}
            <span
              className={`${styles["icon-ic_arrow_right"]} ${showSubLinks ? styles.arrowUp : styles.arrowDown} ${styles.arrowIco}`}
            />
          </div>
        )}
      </div>
      {showSubLinks && hamburgerData?.subLinks && hamburgerData?.subLinks?.length > 0 && (
        <ul className={styles.subListMain}>
          {hamburgerData.subLinks.map((data) => {
            return (
              <li className={styles.subList} key={`subLinks_${data?.title}`}>
                <Link href={data?.link} onClick={() => handleOpen(false)}>
                  {data?.title}
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
};

export default HamburgerInfo;
